<template>
  <div class="search_nav">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="时间维度：">
        <el-select v-model="formInline.queryType" placeholder="请选择" style="width: 120px;" @change="onqueryTypeChange">
          <el-option label="按月" :value="2" />
          <!-- <el-option label="按日" :value="1" /> -->
        </el-select>
      </el-form-item>
      <el-form-item label="交易日期：">
        <el-date-picker
            v-model="formInline.dateRange"
            :type="formInline.queryType === 2 ? 'monthrange' : 'daterange'"
            :value-format="formInline.queryType === 2 ? 'YYYY-MM' : 'YYYY-MM-DD'"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="截止时间"
            style="width: 280px;"
        />
      </el-form-item>
      <el-form-item>
        <template v-if="formInline.queryType === 2">
          <el-button type="primary" @click="quickDate('oneMonth')">近一个月</el-button>
          <el-button type="primary" @click="quickDate('threeMonths')">近三个月</el-button>
          <el-button type="primary" @click="quickDate('sixMonths')">近六个月</el-button>
        </template>
        <template v-else>
          <el-button type="primary" @click="quickDate('threeDays')">近三日</el-button>
          <el-button type="primary" @click="quickDate('oneWeek')">近一周</el-button>
        </template>
      </el-form-item>
      <el-form-item label="支付渠道：">
        <el-select v-model="formInline.payType" placeholder="请选择" style="width: 200px;" @change="onPayTypeChange">
          <el-option label="平台账户" :value="1" />
          <el-option label="建行商户号" :value="12" />
          <el-option label="微信商户号" :value="10" />
          <el-option label="招行商户号" :value="14" />
          <el-option label="微信支付分" :value="13" />
          <el-option label="招行微信支付分" :value="15" />
          <el-option label="人工退款" :value="8" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <div class="button_group">
          <el-button type="primary" @click="getList">搜索</el-button>
          <el-button type="primary" @click="getList">刷新</el-button>
          <el-button type="primary" @click="exportData">导出</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>

  <!-- 统计信息 -->
  <!-- <div class="statistics_info">
    <span>累计充值金额{{ statisticsInfo.rechargeAmt || '0.00' }}元，累计消费金额{{ statisticsInfo.consumeAmt || '0.00' }}元，累计退款{{ statisticsInfo.refundAmt || '0.00' }}元，钱包余额{{ statisticsInfo.balance || '0.00' }}元</span>
  </div> -->

  <el-table ref="cashFlowTable" class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'center'}" :cell-style="{'text-align':'center'}">
    <el-table-column label="交易日期" width="120">
      <template #default="scope">
        <span>{{ scope.row.tradeDate || '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="支付渠道" width="150">
      <template #default="scope">
        <span>{{ scope.row.payTypeName || '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column v-for="col in tableColumns" :key="tableView + '-' + col.prop" :label="col.label">
      <template #header>
        <el-tooltip :content="col.label" placement="top" effect="dark" :disabled="!headerTips[tableView + '-' + col.prop]">
          <span class="header-label" :data-tip-key="tableView + '-' + col.prop" @mouseenter="handleHeaderHover($event, col)">{{ col.label }}</span>
        </el-tooltip>
      </template>
      <template #default="scope">
        <span>{{ fmtCell(scope.row, col) }}</span>
      </template>
    </el-table-column>
  </el-table>

  <!-- 分页 -->
  <Pagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      :total="total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
  />
</template>

<script>
import { ElMessage } from 'element-plus';

function appendMonthLastDayStandard(input) {
  let [year, month] = input.split('-').map(Number);
  let lastDay = new Date(year, month, 0).getDate();

  let mm = String(month).padStart(2, '0');
  let dd = String(lastDay).padStart(2, '0');

  return `${year}-${mm}-${dd}`;
}

export default {
name:'CashFlow',
data() {
return {
    tableData: [],
    total: 0,
    currentPage: 1,
    pageSize: 10,
    currentDate: '',
    headerTips: {}, // 表头文字是否超长被省略的标记，超长的才显示tooltip
    formInline: {
        queryType: 2, // 1:按日维度 2:按月维度
        dateRange: [],
        payType: 1, // 默认选中平台账户
    },
    statisticsInfo: {},
}
},
computed:{
  // 根据支付渠道决定列表列：platform-平台账户 channel-建行/微信/招行商户号及人工退款 payScore-微信支付分/招行微信支付分 all-全部
  tableView() {
    const payType = this.formInline.payType;
    if (payType === 1 || payType === '1') return 'platform';
    if (payType === 13 || payType === '13' || payType === 15 || payType === '15') return 'payScore';
    if (payType === '' || payType === null || payType === undefined) return 'all';
    return 'channel';
  },
  // 各支付渠道对应的列表列（交易日期、支付渠道两列固定，不在此配置）
  // onlyFor: 仅这些 payType 显示数值，其余显示 --；hideFor: 这些 payType 显示 --
  tableColumns() {
    if (this.tableView === 'platform') {
      return [
        { label: '应结算金额', prop: 'shouldSettleAmt', onlyFor: [1] },
        { label: '电费金额', prop: 'elecAmt', onlyFor: [1] },
        { label: '充电服务费', prop: 'discSvcAmt', onlyFor: [1] },
        { label: '订单已结算金额', prop: 'settledAmt', onlyFor: [1] },
        { label: '未结算金额', prop: 'unsettledAmt', onlyFor: [1] },
        { label: '用户账户余额', prop: 'walletBalance' },
      ];
    }
    if (this.tableView === 'channel') {
      return [
        { label: '充值金额', prop: 'rechargeAmt', hideFor: [8] },
        { label: '退款金额', prop: 'refundAmt' },
        { label: '渠道净收入', prop: 'netIncome', hideFor: [8] },
        { label: '渠道手续费', prop: 'handlingFee', hideFor: [8] },
        { label: '实际结算金额', prop: 'settleAmt', hideFor: [8] },
      ];
    }
    if (this.tableView === 'payScore') {
      return [
        { label: '充值金额', prop: 'rechargeAmt' },
        { label: '应结算金额', prop: 'shouldSettleAmt' },
        { label: '电费金额', prop: 'elecAmt' },
        { label: '充电服务费', prop: 'discSvcAmt' },
        { label: '订单已结算金额', prop: 'settledAmt' },
        { label: '未支付金额', prop: 'unpaidAmt' },
        { label: '渠道净收入', prop: 'netIncome' },
        { label: '渠道手续费', prop: 'handlingFee' },
        { label: '实际结算金额', prop: 'settleAmt' },
      ];
    }
    return [
      { label: '充值金额', prop: 'rechargeAmt', hideFor: [8] },
      { label: '电费金额', prop: 'elecAmt', onlyFor: [1] },
      { label: '充电服务费金额', prop: 'svcAmt', onlyFor: [1] },
      { label: '折扣充电服务费', prop: 'discAmt', onlyFor: [1] },
      { label: '实付充电服务费', prop: 'discSvcAmt', onlyFor: [1] },
      { label: '应结算金额', prop: 'shouldSettleAmt', onlyFor: [1] },
      { label: '退款金额', prop: 'refundAmt' },
      { label: '订单已结算金额', prop: 'settledAmt' },
      { label: '未结算金额', prop: 'unsettledAmt' },
      { label: '渠道净收入', prop: 'netIncome', hideFor: [8] },
      { label: '渠道手续费', prop: 'handlingFee', hideFor: [8] },
      { label: '实际结算金额', prop: 'settleAmt', hideFor: [8] },
      { label: '钱包余额', prop: 'walletBalance', hideFor: [8] },
    ];
  },
},
watch:{
  // 列切换后重新检测表头是否超长
  tableColumns() {
    this.$nextTick(this.checkHeaderTips);
  },
},
mounted(){
// this.currentDate = new Date().toISOString().split('T')[0];
// 默认按月份展示今年1月到当前时间
const now = new Date();
const currentYear = now.getFullYear();
const currentMonth = String(now.getMonth() + 1).padStart(2, '0');
this.formInline.dateRange = [`${currentYear}-01`, `${currentYear}-${currentMonth}`];
this.getList();
this.$nextTick(this.checkHeaderTips);
window.addEventListener('resize', this.checkHeaderTips);
},
beforeUnmount(){
window.removeEventListener('resize', this.checkHeaderTips);
},
methods:{
  // 单元格显示：空值显示 --，并按 onlyFor/hideFor 规则隐藏
  fmtCell(row, col) {
    if (col.onlyFor && !col.onlyFor.includes(row.payType)) return '--';
    if (col.hideFor && col.hideFor.includes(row.payType)) return '--';
    const val = row[col.prop];
    if (val === null || val === undefined || val === '') return '--';
    return val || '0.00';
  },
  // 检测表头文字是否超长被省略，超长的才启用tooltip
  checkHeaderTips() {
    const tableEl = this.$refs.cashFlowTable && this.$refs.cashFlowTable.$el;
    if (!tableEl) return;
    const tips = {};
    tableEl.querySelectorAll('.header-label').forEach(el => {
      const key = el.dataset.tipKey;
      if (key) tips[key] = el.scrollWidth > el.offsetWidth;
    });
    this.headerTips = tips;
  },
  // 鼠标移入时校正一次，兼容渲染后宽度变化的情况
  handleHeaderHover(e, col) {
    const el = e.target;
    this.headerTips[this.tableView + '-' + col.prop] = el.scrollWidth > el.offsetWidth;
  },
  //获取统计信息
  getTotal(){
    let that = this;
    let param = {};
    param.page = that.currentPage;
    param.pageSize = that.pageSize;
    param.queryType = that.formInline.queryType;
    param.payType = that.formInline.payType;
    if (this.formInline.dateRange && this.formInline.dateRange.length > 0) {
      let startDate = this.formInline.dateRange[0];
      let endDate = this.formInline.dateRange[1];
      
      // 如果是按月维度，补全日期
      if (that.formInline.queryType === 2) {
          startDate = startDate + '-01'; // 月初
          endDate = appendMonthLastDayStandard(endDate); // 月末
      }
    
      param.startDate = startDate;
      param.endDate = endDate;
    }
    that.$axios.post(that.$store.state.platformApi + "cashFlow/total", JSON.stringify(param)).then(result => {
        if(result.code == 200){
            that.statisticsInfo = result.data;
        }
    });
  },
  // 获取列表
getList(){
    let that = this;
    let param = {};
    param.page = that.currentPage;
    param.pageSize = that.pageSize;
    param.queryType = that.formInline.queryType;
    param.payType = that.formInline.payType;
    if (this.formInline.dateRange && this.formInline.dateRange.length > 0) {
      let startDate = this.formInline.dateRange[0];
      let endDate = this.formInline.dateRange[1];
      
      // 如果是按月维度，补全日期
      if (that.formInline.queryType === 2) {
          startDate = startDate + '-01'; // 月初
          endDate = appendMonthLastDayStandard(endDate); // 月末
      }
    
      param.startDate = startDate;
      param.endDate = endDate;
    }
    
    that.$axios.post(that.$store.state.platformApi + "cashFlow/statistics", JSON.stringify(param)).then(result => {
        if(result.code == 200){
            that.tableData = result.data.page.records;
            that.total = result.data.page.total;
            let fristObj = {};
            fristObj.payTypeName = '期初余额';
            fristObj.walletBalance = result.data.openingBalance;
            that.tableData.unshift(fristObj);
        }
    });
    // 统计信息暂时隐藏，不请求cashFlow/total接口
    // that.getTotal();
},
handleSizeChange(val) {
    this.pageSize = val;
    this.getList();
},
handleCurrentChange(val) {
    this.currentPage = val;
    this.getList();
},
onqueryTypeChange() {
    // 切换时间维度时清空日期范围
    this.formInline.dateRange = [];
},
onPayTypeChange() {
    // 切换支付渠道时回到第一页并按新的payType重新查询
    this.currentPage = 1;
    this.getList();
},
quickDate(type) {
    const now = new Date();
    let startDate, endDate;
    
    if (this.formInline.queryType === 2) {
        // 按月维度
        const currentYear = now.getFullYear();
        const currentMonth = now.getMonth() + 1;
        
        endDate = `${currentYear}-${String(currentMonth).padStart(2, '0')}`;
        
        let startMonth;
        if (type === 'oneMonth') {
            startMonth = currentMonth - 1;
        } else if (type === 'threeMonths') {
            startMonth = currentMonth - 3;
        } else if (type === 'sixMonths') {
            startMonth = currentMonth - 6;
        }
        
        let startYear = currentYear;
        if (startMonth <= 0) {
            startYear = currentYear - 1;
            startMonth = 12 + startMonth;
        }
        startDate = `${startYear}-${String(startMonth).padStart(2, '0')}`;
    } else {
        // 按日维度
        endDate = now.toISOString().split('T')[0];
        
        if (type === 'threeDays') {
            startDate = new Date(now.getTime() - 3 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
        } else if (type === 'oneWeek') {
            startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
        }
    }
    
    this.formInline.dateRange = [startDate, endDate];
},
exportData() {
    let that = this;
    let param = {};
    param.queryType = that.formInline.queryType;
    param.payType = that.formInline.payType;
    if (this.formInline.dateRange && this.formInline.dateRange.length > 0) {
      let startDate = this.formInline.dateRange[0];
      let endDate = this.formInline.dateRange[1];
      
      // 如果是按月维度，补全日期
      if (that.formInline.queryType === 2) {
          startDate = startDate + '-01'; // 月初
          endDate = appendMonthLastDayStandard(endDate); // 月末
      }
    
      param.startDate = startDate;
      param.endDate = endDate;
    }
    // console.log('导出参数:',param);
    that.$axios.post(that.$store.state.platformApi + "cashFlow/export", JSON.stringify(param), {responseType: 'blob'}).then(result => {
        // 处理下载
    });
}
}
}
</script>

<style lang="scss" scoped>
.search_nav{
padding: 15px;
background: #fff;
margin-bottom: 15px;
}
.button_group{
display: flex;
align-items: center;
justify-content: flex-end;
button{
    margin-left: 10px;
}
}
.statistics_info{
padding: 15px;
background: #fff;
margin-bottom: 15px;
color: #666;
font-size: 14px;
}
.header-label{
display: block;
white-space: nowrap;
overflow: hidden;
text-overflow: ellipsis;
}
</style>